// extracted by mini-css-extract-plugin
export default {"fontGrren":"CartEmpty_fontGrren__nVEQP","fontGreen":"CartEmpty_fontGreen__2JLBL"};